import { H3 } from '../../../common/components/texts';
import { appConfig } from '../../../config';
import styles from './FetchErrorMessage.module.css';

const FetchErrorMessage = () => (
  <H3 className={styles.serviceFetchError}>
    Noe gikk galt. Prøv å laste inn siden på nytt. Hvis det fortsatt ikke går, kan du ta kontakt med
    oss{' '}
    <a style={{ color: '#3d0d11' }} href={`${appConfig.typeform.url}`}>
      her
    </a>{' '}
    for å booke time.
  </H3>
);

export default FetchErrorMessage;
